import Elemento from "./Elemento.js";

export default class Coleccion extends Elemento {
  constructor() {
    super();
    this.pano = false;
    this.position;
    this.sides = new Array();
    this.sideSel = {
      Live: {},
      Delay: {},
    };

    this.GetSide = function (cod) {
      return this.sides.filter((side) => side.cod == cod)[0];
    };
  }
}
